import $ from 'jQuery';

// Constants
const API_URL = 'https://piaf-messages.herokuapp.com/api/v1/messages';
const STORAGE_KEY_SUFFIX = '-recipient-agency';


// DOM elements
let form;
let success;
let sendButton;
let revoIframe;


// Configuration
// One or more agencies that are meant to receive the emails
const agencyEmails = {
  rytz: 'vente@rytz.com',
};

const devEmail = 'leopold@drawbotics.com';
const development = false;

const project = 'Lussy sur Morges';
const projectSlug = 'lussy';
const multiLanguage = false;


// Logic
/// Acquires DOM elements, chooses an agency, and attaches the submit form handler to the submit event.
function init() {
  form = $('.js-form-submit');
  sendButton = $('.Contact--send');
  success = $('.Contact--success');
  setAgency();

  if (form[0]) {
    form.on('submit', handleSubmitForm);
  }
}

/// Chooses an agency at random or reads it from the URL, stores the result, and sets the recipient email for the revo URL;
function setAgency() {
  const localStorageKey = `${projectSlug}${STORAGE_KEY_SUFFIX}`;

  const keys = Object.keys(agencyEmails);
  const URLParam = getUrlParameter('agency');
  const agency = keys.indexOf(URLParam) >= 0 ? URLParam : selectRandomFrom(keys);
  localStorage[localStorageKey] = agency;

  // if (agency === 'latour') {
  //   $('#agency-latour').addClass('agency_visible');
  // }
  // else {
  //   $('#agency-victoire').addClass('agency_visible');
  // }
  const email = development ? devEmail : agencyEmails[agency];
  revoIframe = $('#revo-iframe')[0];
  const revoEmail = multiLanguage ? `&email=${email}` : `?email=${email}`;
  revoIframe.src += revoEmail;
} 

/// Creates the email message from the form fields and sends the email.
function handleSubmitForm() {
  const name    = form[0]['firstname'].value;
  const surname = form[0]['lastname'].value;
  const email   = form[0]['email'].value;
  const phone   = form[0]['phone'].value;
  const message = form[0]['message'].value;

  const localStorageKey = `${projectSlug}${STORAGE_KEY_SUFFIX}`;  
  const recipient = development ? devEmail : agencyEmails[localStorage[localStorageKey]];

  const data = {
    message: {
      recipient: recipient,
      project: project,
      content: message,
      phone: phone,
      name: `${name} ${surname}`,
      sender: email,
      project_slug: projectSlug,
    },
  };

  $.ajax({
    url: API_URL,
    data: data,
    type: 'POST',
    crossDomain: true,
    crossOrigin: true,
    dataType: 'json',
  }).done(_requestSuccess);
}

/// Resets the contact form and toggles the "Send" button after the contact email was sent successfully.
function _requestSuccess() {
  success.show(0);
  sendButton.hide(0);
  form[0].reset();
}


// Utils
/// Reads an returns a URL parameter `name` if it exists, otherwise returns null.
function getUrlParameter(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(location.search);
  return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/// Randomly selects and returns a value from an array.
function selectRandomFrom(keys) {
  const idx = parseInt(keys.length * Math.random());
  return keys[idx];
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./src/static/js/modules/submit-form.js